import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface CartButtonProps {
  itemCount: number;
  onClick?: () => void;
}

export function CartButton({ itemCount, onClick }: CartButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className="flex items-center gap-[8px] h-auto px-0 py-0 hover:bg-transparent"
    >
      <div>
        <img
          src="./images/navbar/cart-icon.svg"
          alt="My Logo"
          width={28}
          height={32}
        />
      </div>
      <div className="flex flex-col items-start gap-[4px]">
        <Badge className="h-auto px-1.5 py-0 min-w-[14px] bg-[#F00] text-badge-text text-[10px] font-lexend font-normal tracking-[-0.22px] capitalize rounded-sm">
          {itemCount}
        </Badge>
        <span className="text-[15px] font-lexend font-medium tracking-[-0.22px] capitalize text-text-secondary">
          cart
        </span>
      </div>
    </Button>
  );
}
